import cn from "classnames";
import SaveSearchModal from "components/componentLibrary/Modals/SaveSearchModal";
import React, { useState } from "react";
import { track, analyticsEvents } from "util/analytics";
import { publicSearchPageQuery_city_market_neighborhoods } from "types/pages/office-space/publicSearchPageQuery";
import {
  areaQueryWithCmsContent_area_Market_neighborhoods,
  areaQueryWithCmsContent_area_Neighborhood_market_neighborhoods,
} from "types/pages/office-space/m/areaQueryWithCmsContent";

import styles from "./styles.module.scss";

type Props = {
  showForm: boolean;
  onCancel: () => void;
  market?: string;
  city?: string;
  numberOfEmployees: number;
  neighborhoods:
    | null
    | (
        | publicSearchPageQuery_city_market_neighborhoods
        | areaQueryWithCmsContent_area_Market_neighborhoods
        | areaQueryWithCmsContent_area_Neighborhood_market_neighborhoods
      )[];
  submarkets: { id: string; externalId: string }[];
};

const SaveSearchCTA = ({
  showForm: initShowForm,
  onCancel,
  city,
  submarkets,
  market,
  neighborhoods,
  numberOfEmployees,
}: Props) => {
  const [showForm, setShowForm] = useState(initShowForm);

  const trackEvent = () => {
    track(analyticsEvents.clicked, {
      category: "Public Search CTAs",
      label: "Save Search",
    });
  };

  return (
    <>
      <div
        data-jest="SaveSearchCTA"
        data-testid="SaveSearchCTA"
        className={styles.saveSearchBannerContainer}
      >
        <span className={cn(styles.icon, "icon-bookmark")} />
        <header className={styles.copyContainer}>
          <h1>See new listings faster</h1>
          <p>Get the latest listings directly in your inbox.</p>
        </header>
        <div className={styles.buttonContainer}>
          <button
            data-jest="noThanksButton"
            type="button"
            id="save-search-no-thanks-button"
            name="no-thanks"
            className={`btn-text ${styles.noThanksButton}`}
            onClick={() => {
              trackEvent();
              onCancel();
            }}
          >
            No thanks
          </button>
          <button
            data-jest="saveSearchButton"
            type="button"
            id="save-search-button"
            name="save-search"
            className={`btn-outline ${styles.saveSearchButton}`}
            onClick={() => {
              trackEvent();
              setShowForm(true);
            }}
          >
            SAVE SEARCH
          </button>
        </div>
      </div>
      {showForm && (
        <SaveSearchModal
          city={city}
          submarkets={submarkets}
          market={market}
          neighborhoods={neighborhoods}
          numberOfEmployees={numberOfEmployees}
          onClose={() => {
            setShowForm(false);
            onCancel();
          }}
        />
      )}
    </>
  );
};

export default SaveSearchCTA;
